/**
 * Payment Service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PaymentAccountRequestDto { 
    fakturaCustomerRefNoFilter?: Array<number>;
    connectedUserAccountIdFilter?: Array<number>;
    invoiceStatus?: PaymentAccountRequestDto.InvoiceStatusEnum;
    balanceStatus?: PaymentAccountRequestDto.BalanceStatusEnum;
    prePostStatus?: PaymentAccountRequestDto.PrePostStatusEnum;
    accountNameFilter?: string;
    fakturaCustomerRefNoSearch?: Array<number>;
    userSearch?: Array<number>;
    accountNameSearch?: Array<string>;
    internalCommentSearch?: Array<string>;
    customerRefNoAndAccountNumberSearch?: Array<string>;
    paymentAccountIdFilter?: Array<number>;
    activeFilter?: boolean;
    confirmedFilter?: boolean;
}
export namespace PaymentAccountRequestDto {
    export const InvoiceStatusEnum = {
        Open: 'OPEN',
        Overdue: 'OVERDUE'
    } as const;
    export type InvoiceStatusEnum = typeof InvoiceStatusEnum[keyof typeof InvoiceStatusEnum];
    export const BalanceStatusEnum = {
        Positive: 'POSITIVE',
        Negative: 'NEGATIVE',
        LastsLessThan2Months: 'LASTS_LESS_THAN_2_MONTHS'
    } as const;
    export type BalanceStatusEnum = typeof BalanceStatusEnum[keyof typeof BalanceStatusEnum];
    export const PrePostStatusEnum = {
        Pre: 'PRE',
        Post: 'POST'
    } as const;
    export type PrePostStatusEnum = typeof PrePostStatusEnum[keyof typeof PrePostStatusEnum];
}


export type InvoiceStatusEnum = typeof PaymentAccountRequestDto.InvoiceStatusEnum[keyof typeof PaymentAccountRequestDto.InvoiceStatusEnum];
export type BalanceStatusEnum = typeof PaymentAccountRequestDto.BalanceStatusEnum[keyof typeof PaymentAccountRequestDto.BalanceStatusEnum];
export type PrePostStatusEnum = typeof PaymentAccountRequestDto.PrePostStatusEnum[keyof typeof PaymentAccountRequestDto.PrePostStatusEnum];
